var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.0002 13.3002C5.8092 13.3002 5.6282 13.2262 5.4932 13.0902L0.910195 8.5062C0.774195 8.37119 0.700195 8.1912 0.700195 8.0002C0.700195 7.8092 0.774195 7.6292 0.910195 7.49419L5.4942 2.9102C5.6292 2.7742 5.8092 2.7002 6.0002 2.7002C6.1912 2.7002 6.3712 2.7742 6.5062 2.9102C6.6422 3.0452 6.7162 3.2252 6.7162 3.4172C6.7162 3.6082 6.6412 3.7892 6.5062 3.9242L3.1462 7.28419H14.0602C14.4562 7.28419 14.7772 7.6052 14.7772 8.0002C14.7772 8.3952 14.4562 8.7162 14.0602 8.7162H3.1462L6.5062 12.0772C6.6412 12.2112 6.7162 12.3902 6.7162 12.5822C6.7162 12.7742 6.6422 12.9542 6.5062 13.0902C6.3722 13.2262 6.1912 13.3002 6.0002 13.3002Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrowBack.7c7cb858934d3ce77d027e0758e2de97.svg";
export { ForwardRef as ReactComponent };